import { http } from '@/core/api/';

const apiUrl = 'api/compuminute';

export default {
  async fetchPurposes() {
    const { status, data: response } = await http.get(`${apiUrl}/purposes`);
    return status !== 200 ? [] : response;
  },

  async fetchStatuses() {
    const { status, data: response } = await http.get(`${apiUrl}/statuses`);
    return status !== 200 ? [] : response;
  },

  search(payload) {
    return http.post(`${apiUrl}/search`, payload);
  },

  searchStudents(searchText) {
    return http.get(`${apiUrl}/students/search`, {
      params: { searchText },
    });
  },

  getById(id) {
    return http.get(`${apiUrl}/${id}`);
  },

  fetchAppointmentPreload(appointmentId) {
    return http.get(`${apiUrl}/appointments/${appointmentId}/preload`);
  },

  create(payload) {
    return http.post(apiUrl, payload);
  },

  createDraftFromPei(payload) {
    return http.post(`${apiUrl}/draft-from-pei`, payload);
  },

  getOrCreateDraftFromTriennialDetermination(payload) {
    return http.post(`${apiUrl}/draft-from-triennial-determination`, payload);
  },

  getOrCreateDraftFromEvaluationDiscussion(payload) {
    return http.post(`${apiUrl}/draft-from-evaluation-discussion`, payload);
  },

  update(id, payload) {
    return http.put(`${apiUrl}/${id}`, payload);
  },

  saveEditor(id, payload) {
    return http.put(`${apiUrl}/${id}/editor`, payload);
  },

  autoSaveEditor(id, payload) {
    return http.put(`${apiUrl}/${id}/editor`, payload, {
      headers: {
        skipLoading: true
      }
    });
  },

  saveSignature(id, payload) {
    return http.put(`${apiUrl}/${id}/signature`, payload);
  },

  completeManuscript(id, payload) {
    return http.post(`${apiUrl}/${id}/complete-manuscript`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  downloadManuscriptTemplate(id) {
    return http.get(`${apiUrl}/${id}/manuscript-template`);
  },

  revertToDraft(id) {
    return http.post(`${apiUrl}/${id}/revert-to-draft`);
  },

  discardDraft(id) {
    return http.delete(`${apiUrl}/${id}/draft`);
  },

  syncElectronicCancellation(id) {
    return http.post(`${apiUrl}/${id}/sync-electronic-cancellation`);
  },

  completeElectronic(id) {
    return http.post(`${apiUrl}/${id}/complete-electronic`);
  },

  getCompletedByStudent(sieId) {
    return http.get(`${apiUrl}/student/${sieId}/completed`);
  },

  preview(payload) {
    return http.post(`${apiUrl}/preview`, payload);
  },
};
